import React from 'react';
import './notFound.css'
import {Image} from "react-bootstrap";

function NotFound(props) {
    return (
        <div className={'notfound-content-wrapper'}>
            <div className="gif-wrapper">
                <Image src={'/static/images/NotFound404.svg'}/>
            </div>
        </div>
    );
}

export default NotFound;